import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {NotificationService} from 'app/core/services/notification.service';
import {CatalogService} from '../catalog.service';
import {AmberApi} from 'app/core/models/api-helpers';
import {RxComponent} from 'app/core/components/common/rx.component';

@Component({
    selector: 'itpx-catalog-add',
    templateUrl: './catalog-add.component.html',
    styleUrls: ['./catalog-add.component.css']
})
export class CatalogAddComponent extends RxComponent implements OnInit {

    private form: FormGroup;
    domainOptions$: Observable<any[]>;
    readonly domainSpecificOptions = [{ key: 'mkp', value: 'Marketplace' }, { key: 'dms', value: 'Domain Specific' }, { key: 'lms', value: 'LMS Catalog' }];
    readonly onlineOptions = [{ key: true, value: 'Online' }, { key: false, value: 'Offline' }];

    constructor(
        private fb: FormBuilder,
        private router: Router,
        private service: CatalogService,
        private notificationService: NotificationService
    ) {
        super();
    }

    ngOnInit() {
        this.form = this.fb.group({
            name: [null, [Validators.required, Validators.minLength(3)]],
            code: [null, [Validators.required, Validators.minLength(3), this.noWhitespaceValidator, this.noAmpersandValidator]],
            keywords: [[]],
            domainSpecific: ['mkp', Validators.required],
            online: [true, Validators.required],
            buyerDomains: [null, Validators.required],
            sellerDomains: [null, Validators.required],
            catalogSvg: [null]
        })

        this.form.get('domainSpecific').valueChanges.startWith('mkp').bindToLifecycle(this).subscribe(val => {
            if (val === 'dms' || val === 'lms') {
                this.form.get('buyerDomains').enable({ onlySelf: true, emitEvent: false });
                this.form.get('sellerDomains').enable({ onlySelf: true, emitEvent: false });
            } else {
                this.form.get('buyerDomains').disable({ onlySelf: true, emitEvent: false });
                this.form.get('sellerDomains').disable({ onlySelf: true, emitEvent: false });
            }
        });
        this.form.get('name').valueChanges
            .bindToLifecycle(this)
            .subscribe(name => {
                if (this.form.get('code').pristine) {
                    this.form.patchValue({ code: this.toSlug(name) }, { onlySelf: true, emitEvent: false });
                }
            });
        this.domainOptions$ = this.service.getDomainDict({'@b2b': true}).extract(AmberApi.Data).shareReplay(1);
    }

    public noWhitespaceValidator(control: FormControl) {
        const isWhitespace = -1 < (control.value || '').indexOf(' ');
        const isValid = !isWhitespace;
        return isValid ? null : { 'custom': { message: 'No whitespaces allowed' } };
    }

    public noAmpersandValidator(control: FormControl) {
        const isWhitespace = -1 < (control.value || '').indexOf('&');
        const isValid = !isWhitespace;
        return isValid ? null : { 'custom': { message: 'No ampersand character allowed' } };
    }

    private toSlug(input: string) {
        return input.trim().replace(/ /g, '-').replace(/\&/g, 'and').toLowerCase();
    }

    onSubmit(event: any) {
        let form = this.form.value;
        if (form.buyerDomains) {
            form.buyerDomains = form.buyerDomains.map(id => ({ id: id }));
        }
        if (form.sellerDomains) {
            form.sellerDomains = form.sellerDomains.map(id => ({ id: id }));
        }
        let request = { ...form, domainSpecific: form.domainSpecific !== 'mkp', lmsCatalog: form.domainSpecific === 'lms' };
        this.service.add(request)
            .subscribe(
                data => {
                    this.notificationService.success('Successfully created a catalog', 'Success');
                    this.router.navigate(['/agora/product-data/catalogs']);
                },
                error => {
                }
            )
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/catalogs/add/catalog-add.component.ts